export class GlobalTTSManager {
  private static instance: GlobalTTSManager | null = null;
  private activeTTSId: string | null = null;
  private stateChangeCallbacks: Map<string, () => void> = new Map();

  private constructor() {}

  static getInstance(): GlobalTTSManager {
    if (!GlobalTTSManager.instance) {
      GlobalTTSManager.instance = new GlobalTTSManager();
    }
    return GlobalTTSManager.instance;
  }

  registerTTS(id: string, callback: () => void) {
    this.stateChangeCallbacks.set(id, callback);
  }

  unregisterTTS(id: string) {
    this.stateChangeCallbacks.delete(id);
    if (this.activeTTSId === id) {
      this.activeTTSId = null;
    }
  }

  setActiveTTS(id: string | null) {
    if (this.activeTTSId && this.activeTTSId !== id) {
      // Stop the currently active TTS
      console.log(`GlobalTTSManager: Stopping active TTS ${this.activeTTSId} to start ${id}`);
      this.stopTTS(this.activeTTSId);
    }
    
    this.activeTTSId = id;
    this.notifyStateChange();
  }

  getActiveTTS(): string | null {
    return this.activeTTSId;
  }

  isActiveTTS(id: string): boolean {
    return this.activeTTSId === id;
  }

  stopTTS(id?: string) {
    if (id) {
      // Stop specific TTS instance
      if (this.activeTTSId === id) {
        console.log(`GlobalTTSManager: Stopping specific TTS ${id}`);
        this.activeTTSId = null;
        this.notifyStateChange();
      }
    } else {
      // Stop any active TTS
      console.log(`GlobalTTSManager: Stopping active TTS ${this.activeTTSId}`);
      this.activeTTSId = null;
      this.notifyStateChange();
    }
  }

  stopAllTTS() {
    console.log('GlobalTTSManager: Stopping all TTS instances');
    
    // Import and stop all audio managers
    import('@/utils/audioUtils').then(({ AudioManager }) => {
      AudioManager.getInstance().stop();
    });
    
    import('@/utils/azureAudioManager').then(({ AzureAudioManager }) => {
      AzureAudioManager.getInstance().stopAll();
    });
    
    // Force stop web speech API
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
    
    this.activeTTSId = null;
    this.notifyStateChange();
  }

  private notifyStateChange() {
    this.stateChangeCallbacks.forEach((callback) => callback());
  }
}